export default __webpack_public_path__ + "static/media/museo.87a23bd8.mp4";